import { Checkbox } from '@bp/ui-components';
import classNames from 'classnames';
import { Field, FieldArrayRenderProps, useFormikContext } from 'formik';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { FactorType } from '../../../types/planung-graphql-client-defs';
import { FactorInheritFormType } from './FactorInheritForm';
import styles from './FactorInheritFormRow.module.scss';

type FactorInheritFormRowProps = {
  index: number;
  helper: FieldArrayRenderProps;
};

export const FactorInheritFormRow = ({ index, helper }: FactorInheritFormRowProps) => {
  const { t } = useTranslation();

  const { values, setFieldValue } = useFormikContext<FactorInheritFormType>();

  const {
    factorType,
    grades,
    gradeGroup,
    subject,
    subjectContainer,
    timeGridEntries,
    teachers,
    valueRaw,
    valuePartial,
    comment,
    selected,
  } = values[index];

  return (
    <div className={classNames(styles['factor-inherit-form-row'], { [styles.selected]: selected })}>
      <div className={styles.checkbox}>
        <Field
          as={Checkbox}
          name={`${helper.name}.${index}.selected`}
          checked={selected}
          onChange={async (e: ChangeEvent<HTMLInputElement>) =>
            await setFieldValue(`${index}.selected`, e.target.checked)
          }
        />
      </div>
      <div className={styles.small}>
        {factorType === FactorType.Base
          ? t('factors.base')
          : factorType === FactorType.Time
            ? t('factors.time')
            : t('factors.person')}
      </div>
      <div className={styles.small}>{grades.length === 0 ? t('common.all') : grades.join(', ')}</div>
      <div className={styles.small}>
        {gradeGroup.length === 0 ? t('common.all') : gradeGroup.map((s) => s.name).join(', ')}
      </div>
      <div className={styles.large}>
        {subject.length === 0 ? t('common.all') : subject.map((s) => s.name).join(', ')}
      </div>
      <div className={styles.medium}>
        {subjectContainer.length === 0
          ? factorType === FactorType.Time
            ? t('common.all')
            : '-'
          : subjectContainer.map((s) => s.shortName).join(', ')}
      </div>
      <div className={styles.small}>
        {timeGridEntries.length === 0
          ? factorType === FactorType.Base
            ? t('common.all')
            : '-'
          : timeGridEntries.map((t) => t.name).join(', ')}
      </div>
      <div className={styles.small}>
        {teachers.length === 0
          ? factorType === FactorType.Person
            ? t('common.all')
            : '-'
          : teachers.map((s) => s.shortName).join(', ')}
      </div>
      <div className={styles.small}>{valueRaw ? valueRaw.toString() : ''}</div>
      <div className={styles.small}>{valuePartial ? valuePartial.toString() : ''}</div>
      <div className={styles.comment}>{comment}</div>
    </div>
  );
};
